import React from "react";

import DisabledImagesOrders from "./DisabledImagesOrders";
import EnabledImagesOrders from "./EnabledImagesOrders";

export default function ImagesOrders({ asset, disabledForm }) {
  if (disabledForm) {
    return <DisabledImagesOrders asset={asset} />;
  }
  return <EnabledImagesOrders asset={asset} />;
}
